import { DeepPartial } from 'redux';
import { SET_CONFIG, SET_WIDGET, UPDATE_OPTIONS, SET_EXPORTED } from './constants/actionTypes';
import { Config, Widget, OptionsState, ExportedState } from './types';

export const setConfig = (payload: Config) => ({ type: SET_CONFIG, payload });
export const setWidget = (payload: Widget) => ({ type: SET_WIDGET, payload });
export const updateOptions = (payload: DeepPartial<OptionsState>) => ({ type: UPDATE_OPTIONS, payload });
export const setExported = (payload: ExportedState) => ({ type: SET_EXPORTED, payload });
